import { getI18n } from 'react-i18next';
import { Action } from 'redux-actions';
import { call, fork, put, take } from 'redux-saga/effects';
import Command from '../action/command';
import Event from '../action/event';
import {
    onEnqueueErrorSnackbar,
    onEnqueueSuccessSnackbar,
} from './enqueueSnackbarFlow';
import { UpdateIssueReportStatusPayload } from '../action/issueReportsCommands';
import { Api } from '../api';
import Logger from '../common/logger';

const onUpdateIssueReportStatus = function* (
    issueReportId: string,
    status: string,
) {
    try {
        yield call(Api.updateIssueReportStatus, issueReportId, status);
        yield fork(
            onEnqueueSuccessSnackbar,
            getI18n().t('snackbar.success.update_issue_report'),
            12000,
        );
        yield put(
            Event.IssueReport.updatedIssueReportStatus({
                id: issueReportId,
                status,
            }),
        );
        return;
    } catch (error) {
        Logger('Saga').error(error);
        yield fork(
            onEnqueueErrorSnackbar,
            getI18n().t('snackbar.error.update_issue_report'),
        );
    }

    yield put(
        Event.IssueReport.updatedIssueReportStatus({
            id: issueReportId,
            status,
        }),
    );
};

export function* updateIssueReportStatusFlow() {
    while (true) {
        const action: Action<UpdateIssueReportStatusPayload> = yield take(
            Command.IssueReport.updateIssueReportStatus.toString(),
        );
        yield fork(
            onUpdateIssueReportStatus,
            action.payload.id,
            action.payload.status,
        );
    }
}
